import { useCallback } from 'react';
import { useSite } from 'src/context/providers/SiteProvider';
import { openDrawer } from 'src/context/reducers/drawerSlice';

const PROFILE_DRAWER_ID = 'profile';

/**
 * Open a provider's profile in the profile drawer.
 *
 * @returns A stable `(providerId, type?) => void`. A missing type is passed as
 * `null`, as the other `SET_CURRENT_PROVIDER` callers do.
 */
export function useOpenProviderProfile() {
  const { dispatch } = useSite();
  return useCallback(
    (providerId: string, type?: string | null) => {
      if (!providerId) return;
      dispatch({
        type: 'SET_CURRENT_PROVIDER',
        payload: { id: providerId, type: type || null },
      });
      dispatch(openDrawer({ id: PROFILE_DRAWER_ID }));
    },
    [dispatch]
  );
}
